import React from 'react'
import Footer from '../../Footer/footer'

const Contact = () => {
  return (
    <div className='container-contact'>
      <div className='wrapper-beranda'>
        <div className='hero-beranda'>
                <h1>contact</h1>
              <div className='hero-img'>
              </div>
        </div>
      </div>
          <Footer />
    </div>
  )
}

export default Contact
